import React from 'react';
import { useRouter } from 'next/router';
import { BaseConstWebappUrl } from '@soundxyz/utils/constants/embeds';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { ModalContext } from '@context/modal';
import { SmallShare } from './SmallShare';

export function ShareModalViral() {
  const { closeCancelModal } = ModalContext.useContainer();
  const { pathname } = useRouter();

  const url = `${BaseConstWebappUrl}${pathname?.substring(1)}`;

  const body = <SmallShare url={url} type="viral" />;

  return (
    <StandardModal
      body={body}
      title="Share"
      closeModal={closeCancelModal}
      bodyWithoutPaddingBottom
    />
  );
}
